import { Injectable } from '@angular/core';
import { HttpParams, HttpEventType, HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject, ReplaySubject, forkJoin, throwError } from 'rxjs';

import { RegistrationUrls } from '../global.urls';
import * as Classes from '../classes/models.classes';
import { ShortsPostSave } from '../interfaces/models.interfaces';
import { tap } from 'rxjs/operators';

//import { Http } from '@angular/http';

@Injectable({
    providedIn: 'any'
})
export class GIFEmojiService {
    private apiKey = 'AIzaSyAPHPIKxjZsEXon0UQlPA1TxmWJx-oecI8';
    private apiUrl = 'https://tenor.googleapis.com/v2';

    constructor(private http: HttpClient) { }

    searchGifs(searchTerm: string, limit: number = 20, offset: number = 0): Observable<any> {
        const url = `${this.apiUrl}/search?q=${encodeURIComponent(searchTerm)}&key=${this.apiKey}&limit=${limit}&pos=${offset}`;
        return this.http.get(url);
    }
}


